import * as React from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { DynamicText, FormManager, FormRow, Grid, PageTitle, useCacheQuery, useCloneEntity } from 'gossamer-front-end';
import { InstitutionMember, InstitutionMemberRow, UserView } from 'cb-model';
import { getFilter, getListRowLink } from 'gossamer-unified';

export const InstitutionMemberGrid = (): React.JSX.Element => {
  const params = useParams();
  const navigate = useNavigate();
  const query = useCacheQuery(InstitutionMember, {
    where: { and: [getFilter('user_id', 'eq', params.key)] },
    order: [['created_at', 'ASC']],
  });
  const handleExit = () => navigate(getListRowLink(UserView.listRowLink, params.key));
  const LocalInstitutionMember = useCloneEntity(InstitutionMember, (clone) => {
    clone.fields.user_id.listColumn = false;
  });

  return (
    <>
      <PageTitle title="Amend Institution Memberships" />
      <p>
        For{' '}
        <b>
          <DynamicText text={`<lookup:UserView:${params.key}>`} />
        </b>
        . The user can only be an admin for one institution. If making the user an admin, remember to also ensure they
        are marked verified.
      </p>
      <FormManager
        compoundUrl={`/main/institution-member-update-multi`}
        handleCancel={handleExit}
        handleSuccess={(_resp, resetCache) => {
          resetCache(UserView.id, params.key);
          handleExit();
        }}
        initialization={{
          main: {
            type: 'update-multi',
            entity: LocalInstitutionMember,
            query,
          },
        }}
      >
        <Grid
          valuesKey="main"
          entity={LocalInstitutionMember}
          addRowFieldId="institution_id"
          onAddRow={(data: FormRow<InstitutionMemberRow>, newValue: string) => {
            data.user_id = params.key;
            data.institution_id = parseInt(newValue);
          }}
        />
      </FormManager>
    </>
  );
};
